let slideIndex = 1;
let kendallLocation = document.getElementsByClassName("myKendallSlides");
let doralLocation = document.getElementsByClassName("myDoralSlides");
let pompanoLocation = document.getElementsByClassName("myPompanoSlides");

showSlides(location, slideIndex);

function plusSlides(location, n) {
  showSlides(location, (slideIndex += n));
}

function currentSlide(location, n) {
  showSlides(location, (slideIndex = n));
}

function showSlides(location, n) {
  if (location.length === undefined) {
    console.log(kendallLocation[0]);
    kendallLocation[0].style.display = "block";
    doralLocation[0].style.display = "block";
    pompanoLocation[0].style.display = "block";
  } else {
    let i;
    let slides = document.getElementsByClassName(location);
    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    slides[slideIndex - 1].style.display = "block";
  }
}
